import { supabase } from '../lib/supabase';
import { Sentry } from '../lib/sentry';
import { CT } from '../lib/theme';


const PSPS_DOTS = [
  { letter: 'P', color: CT.orange },
  { letter: 'S', color: CT.purple },
  { letter: 'P', color: CT.blue },
  { letter: 'S', color: CT.green },
] as const;

const ERROR_MESSAGES: Record<string, string> = {
  signup_disabled: 'New sign-ups are currently disabled. Please contact your administrator.',
  access_denied: 'Access was denied. Please try again or contact your administrator.',
};

function getAuthError(): string | null {
  const params = new URLSearchParams(window.location.search);
  const hash = new URLSearchParams(window.location.hash.replace('#', '?'));
  const error = params.get('error') || hash.get('error');
  const errorCode = params.get('error_code') || hash.get('error_code');
  const errorDesc = params.get('error_description') || hash.get('error_description');

  if (error || errorCode || errorDesc) {
    const rawMessage = errorDesc?.replace(/\+/g, ' ') ?? errorCode ?? error ?? 'unknown';
    Sentry.captureMessage(`Auth error: ${rawMessage}`, {
      level: 'error',
      tags: { auth_error_code: errorCode ?? error ?? 'none' },
      extra: { error, error_code: errorCode, error_description: rawMessage },
    });
  }

  if (errorCode && ERROR_MESSAGES[errorCode]) return ERROR_MESSAGES[errorCode];
  if (error && ERROR_MESSAGES[error]) return ERROR_MESSAGES[error];
  if (errorDesc) return errorDesc.replace(/\+/g, ' ');
  return null;
}

export default function AuthGate() {
  const authError = getAuthError();

  async function handleSignInWithGoogle() {
    await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: window.location.origin },
    });
  }

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        background: CT.darkGrey,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: CT.font,
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 32 }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {PSPS_DOTS.map((d, i) => (
            <span
              key={i}
              style={{
                width: 48,
                height: 48,
                borderRadius: '50%',
                boxShadow: '0 0 0 3px #252A31',
                background: d.color,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: CT.darkGrey,
                fontSize: 20,
                fontWeight: 600,
                fontFamily: CT.font,
                marginLeft: i === 0 ? 0 : -10,
              }}
            >
              {d.letter}
            </span>
          ))}
        </div>

        <div style={{ textAlign: 'center' }}>
          <div
            style={{
              color: CT.white,
              fontSize: 18,
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 6,
              marginBottom: 10,
            }}
          >
            <span style={{ color: CT.orange }}>Persona</span>
            <span style={{ color: CT.paleGrey }}>→</span>
            <span style={{ color: CT.purple }}>Situation</span>
            <span style={{ color: CT.paleGrey }}>→</span>
            <span style={{ color: CT.blue }}>Pain</span>
            <span style={{ color: CT.paleGrey }}>→</span>
            <span style={{ color: CT.green }}>Solution</span>
          </div>
          <p
            style={{
              color: CT.paleGrey,
              fontSize: 14,
              lineHeight: 1.5,
              margin: 0,
            }}
          >
            Sign in to explore the research map with real-time updates.
          </p>
        </div>

        {authError && (
          <div
            style={{
              color: '#f87171',
              fontSize: 13,
              lineHeight: 1.5,
              textAlign: 'center',
              maxWidth: 340,
            }}
          >
            {authError}
          </div>
        )}

        <button
          onClick={handleSignInWithGoogle}
          style={{
            background: CT.primaryBlue,
            color: CT.white,
            border: 'none',
            borderRadius: 8,
            padding: '14px 32px',
            fontSize: 15,
            fontWeight: 500,
            fontFamily: CT.font,
            cursor: 'pointer',
            letterSpacing: '0.01em',
          }}
        >
          Sign in with Google
        </button>
      </div>
    </div>
  );
}
